import { render } from "./MenuItemCard.vue?vue&type=template&id=39eb5d48&scoped=true"
import script from "./MenuItemCard.vue?vue&type=script&lang=js"
export * from "./MenuItemCard.vue?vue&type=script&lang=js"

import "./MenuItemCard.vue?vue&type=style&index=0&id=39eb5d48&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-39eb5d48"

export default script